module.exports = __webpack_public_path__ + "img/1300_Social_header.f049c31a.png";